import { DOC_TYPE, REPORT_TYPE } from 'config'

export function getReportType(documentType: string) {
  if (
    documentType === DOC_TYPE.INVOICE ||
    documentType === DOC_TYPE.ORDER_FORM
  ) {
    return REPORT_TYPE.SPECIFIC
  }
  return REPORT_TYPE.TEMPLATE
}
